import React, { Component } from "react";

//Loader import
import Loader from "../loader";

//Service import
import service from "../../services";

//moment import
import moment from "moment-timezone";

//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "../../redux/bindActionCretor";

import PopUpCustomAll from "../fpg/create/popUpCustomAll";
import GeneralDisplayTemplate from "./generalDisplayTemplate";
import PanelDisplayTemplate from "./panelDisplayTemplate";
import ScreeningDisplayTemplate from "./screeningDisplayTemplate";
import OfferDisplayTemplate from "./offerDisplayTemplate";
import { Link } from "react-router-dom";
import FpgDisableIcon from "../../icons/fpgdisableicon";
import FpgpublishIcon from "../../icons/fpgpublishicon";
import FpgDeleteIcon from "../../icons/fpgdeleteicon";
import ErrorPopUp from "../errorPopUp";

let sub;

const mapStateToProps = (state) => ({
  getLoginRole: state.getLoginRole,
  getLoginAdminByID: state.getLoginAdminByID,
  storePartnerEvent: state.storePartnerEvent,
  getPartnerDetails:state.getPartnerDetails,
  profileName:state.profileName
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

class SateliteventView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventDisplayTemplate: "Panel",
      loaderFlag: false,
    };
    this.apiserve = new service();
  }

  componentDidMount = () => {
    this.getAllEvent();
    document.body.addEventListener('click', this.bodyClick);
  };

  componentWillUnmount = () => {
    const { storePartnerEvent } = this.props;
    if(storePartnerEvent){
      this.getPerticularEvent();
  }
    sub.unsubscribe();
  }

  getAllEvent = () => {
    sub =  this.apiserve.getevent().subscribe((response) => {
        switch (response.event) {
        case "FestivalVillage|SatelliteScreen|getSatelliteEventById":
            this.setState({
              eventId:response.data._id,
              eventDisplayTemplate: response.data.eventDisplayTemplate,
              updateDate:response.data.updatedAt,
              updatedBy:response.data.updatedBy,
              status:response.data.status
            })
            this.setState({loaderFlag:false})       
            break;
            case "FestivalVillage|Event|deleteEvent":
              if(!response.error){
                this.props.history.push('/satellite-adminview')
              }else{
                this.setState({
                  errorPopup: true,
                  deleteFilm: false,
                  errorMsg: response.data.error ? response.data.error : response.data
                })
              }
            break;
            case "FestivalVillage|Event|updateStatus":
              if (!response.error) {
                this.props.history.push("/satellite-adminview");
              } else {
                this.setState({
                  errorPopup: true,
                  disableFilm:false,
                  publishFilm:false,
                  errorMsg: response.data.error ? response.data.error : response.data
                })
              }
            break;
        }
    });
    };

    getPerticularEvent = () => {
      const { storePartnerEvent } = this.props;
      this.apiserve.sendevent("FestivalVillage|SatelliteScreen|getSatelliteEventById", {
          id: storePartnerEvent._id,
      });
      this.setState({loaderFlag:true})
      };


// Body Click
  bodyClick = (e) => {
  if(document.querySelector('.popup_wrapper')) {      
    if(!e.target.closest('.popup_wrapper')) {
      this.setState({
        featurePopup: false,
        titlePopup: false
      })
    }
    }
  }
 
  onDisplayTemplateChange = (event) => {
    this.setState({
      eventDisplayTemplate: event.target.value,
    });
  };

  onDisplayTypeChange = (event) => {
    this.setState({
      displayType: event.target.value,
    });
  };

  onDisplayTypeChange = (event) => {
    this.setState({
      displayType: event.target.value,
    });
  };

  closeAdminUser = () => {
    this.setState({
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
    });
  };

  deleteFilm = () => {
    this.setState({
      deleteFilm: true,
    });
  };

  deleteFilmPopupYes = () => {
    const { storePartnerEvent } = this.props;

    this.apiserve.sendevent("FestivalVillage|Event|deleteEvent", {
      id: storePartnerEvent._id,
    });
  };

  publishFilm = () => {
    this.setState({
      publishFilm: true,
    });
  };

  publishFilmPopupYes = () => {
    const { storePartnerEvent } = this.props;
    this.apiserve.sendevent("FestivalVillage|Event|updateStatus", {
      id: storePartnerEvent._id,
      status: 1,
    });
  };

  disableFilm = () => {
    this.setState({
      disableFilm: true,
    });
  };

  disableFilmPopupYes = () => {
    const { storePartnerEvent } = this.props;
    this.apiserve.sendevent("FestivalVillage|Event|updateStatus", {
      id: storePartnerEvent._id,
      status: 2,
    });
  };

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    })
  }

render() {
  const { eventDisplayTemplate } = this.state;
  const {getLoginRole,profileName} = this.props
   return (
      <React.Fragment>
          <div className="right_side_wrapper partnerEventAdminView_wrapper  fest_contents p_0">
            <div className="dashboard_header with_btn">
              <div className="searchBlock">
                <span>
                Partner Events {` > `} {this.state.eventId ? 'Edit Event' : 'Create Event'}</span>
              </div>
            </div>
            {this.state.eventId &&
            <>
              <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
             <Link className="back_link" to='/satellite-adminview'> <svg width="5" height="10" viewBox="0 0 5 10" fill="none"> <path d="M5 0L0 5L5 10V0Z" fill="black"/> </svg> Back To List</Link>
              <p className="update_date">
                Last Update: {moment(this.state.updateDate).tz("US/Mountain").format('h')}:{moment(this.state.updateDate).tz("US/Mountain").format('mm')} {moment(this.state.updateDate).tz("US/Mountain").format('A')}{' '}
                MT- {moment.tz(this.state.updateDate, "US/Mountain").format('MM/DD/YYYY')} Last Updated By: {this.state.updatedBy && this.state.updatedBy.fname} {this.state.updatedBy && this.state.updatedBy.lname}
              </p>
            </div>
            </>
            }
            <div className="tabset">
              {/* <div className="tabBlock">
                <div>
                  <h5>Select Event Display Template: </h5>
                  <div className="tabWrapper">
                    <div>
                      <input
                        type="radio"
                        name="tabset"
                        id="tab1"
                        aria-controls="General"
                        checked={this.state.eventDisplayTemplate === "General"}
                        value="General"
                        onChange={(e) => this.onDisplayTemplateChange(e)}
                      />
                      <label htmlFor="tab1">General</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="tabset"
                        id="tab2"
                        aria-controls="Screening"
                        checked={
                          this.state.eventDisplayTemplate === "Screening"
                        }
                        value="Screening"
                        onChange={(e) => this.onDisplayTemplateChange(e)}
                      />
                      <label htmlFor="tab2">Screening</label>
                    </div>
                    <div className="mr_10">
                      <input
                        type="radio"
                        name="tabset"
                        id="tab3"
                        aria-controls="Panel"
                        checked={this.state.eventDisplayTemplate === "Panel"}
                        value="Panel"
                        onChange={(e) => this.onDisplayTemplateChange(e)}
                      />
                      <label htmlFor="tab3">Panel</label>
                    </div>
                    <div className="ml_15">
                      <input
                        type="radio"
                        name="tabset"
                        id="tab4"
                        aria-controls="Offer"
                        checked={this.state.eventDisplayTemplate === "Offer"}
                        value="Offer"
                        onChange={(e) => this.onDisplayTemplateChange(e)}
                      />
                      <label htmlFor="tab4">Offer</label>
                    </div>
                  </div>
                </div>
             </div> */}
              <div className="tab-panels fpg_tabcontent">
              {this.state.eventId &&
                <div className="fpg_edits_links d_flex d_flex_align_center d_flex_justify_end">
                  {this.state.status === 1 ? (
                    <Link
                      className="d_flex d_flex_align_center d_flex_justify_center mb_0"
                      onClick={() => this.disableFilm()}
                    >
                      <FpgDisableIcon /> DISABLE
                    </Link>
                  ) : (
                      <Link
                        className="d_flex d_flex_align_center d_flex_justify_center mb_0"
                        onClick={() => this.publishFilm()}
                      >
                        <FpgpublishIcon /> PUBLISH
                      </Link>
                    )}
                  <Link
                    className="d_flex d_flex_align_center d_flex_justify_center mb_0"
                    onClick={() => this.deleteFilm()}
                  >
                    <FpgDeleteIcon />
                    DELETE
                  </Link>
                </div>
              }
              {eventDisplayTemplate === 'Panel' ?
                // <>
                //    <GeneralDisplayTemplate generalUserID = {this.props.storePartnerEvent && this.props.storePartnerEvent._id} eventDisplayTemplate='General'/>              
                // </>
                // :
                // eventDisplayTemplate === 'Screening' ? 
                // <>
                //    <ScreeningDisplayTemplate screeningUserID = {this.props.storePartnerEvent && this.props.storePartnerEvent._id} eventDisplayTemplate='Screening'/>              
                // </>
                // :
                // eventDisplayTemplate === 'Panel'?
                <>
                  <PanelDisplayTemplate panalUserID = {this.props.storePartnerEvent && this.props.storePartnerEvent._id} eventDisplayTemplate='Panel'/>
                </>
                :
                // eventDisplayTemplate === 'Offer' ?
                // <>
                //   <OfferDisplayTemplate offerUserID = {this.props.storePartnerEvent && this.props.storePartnerEvent._id} eventDisplayTemplate='Offer'/>
                // </>
                // :
                ""
                }
         
              </div>
            </div>
          </div>
      
        {/* Loader */}
        {this.state.loaderFlag ? <Loader /> : ""}
      
        {this.state.errorPopup ?
            <ErrorPopUp
              errorMsg={this.state.errorMsg}
              errorMsgPopup={this.errorMsgPopup}
            />
            : ''
        }
        
        {this.state.deleteFilm ? (
            <PopUpCustomAll
              HeaderName="Delete?"
              insideDetails="You are about to delete an item and this action is permanent"
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.deleteFilmPopupYes}
            />
          ) : (
              ""
          )}

          {this.state.publishFilm ? (
            <PopUpCustomAll
              HeaderName="Publish Changes"
              insideDetails="Saving the current changes will publish it to the production site"
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.publishFilmPopupYes}
            />
          ) : (
              ""
            )}

          {this.state.disableFilm ? (
            <PopUpCustomAll
              HeaderName="Disable?"
              insideDetails="You are about to disable an item, which will temporarily make it unavailable on the production site"
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.disableFilmPopupYes}
            />
          ) : (
              ""
            )}
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SateliteventView);
